module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D12-clean-c828a3a1bff4e32dea01e78b264f292f.png";